// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#main-menu.ant-menu {\n  margin-left: 5.5rem;\n  font-weight: 500;\n}\n", "",{"version":3,"sources":["webpack://src/assets/styles/MainMenu.less"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["#main-menu.ant-menu {\n  margin-left: 5.5rem;\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
